import ouibounce from 'ouibounce'
import type { logCustomEvent } from '@braze/web-sdk'

export function handleExitIntent({
  eventName,
  properties,
  logEvent,
}: {
  eventName: string
  properties?: Record<string, unknown>
  logEvent: typeof logCustomEvent
}) {
  const ouibounceInstance = ouibounce(false, {
    cookieName: `viewedOuibounce-${eventName}`,
    callback: async function () {
      logEvent(eventName, { ...properties, appName: 'rvezy-rentals' })
    },
  })

  return {
    disable: () => {
      ouibounceInstance.disable()
    },
  }
}
